import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepperComponent } from './creer/components/stepper/stepper.component';
import { HomeAvisDePubComponent } from './home-avis-de-pub/home-avis-de-pub.component';
import { ListerAvisDePubComponent } from './lister-avis-de-pub/lister-avis-de-pub.component';
import { VisualiserAvisDePubComponent } from './visualiser-avis-de-pub/visualiser-avis-de-pub.component';
import {ImportComponent} from './import/import.component';
const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'breadcrumb.avisPub' },
    children: [
      {
        path: 'listerAvisPub',
        component: ListerAvisDePubComponent,
        data: { breadcrumb: 'breadcrumb.listerPub' }
      },
      {
        path: 'visualiser/:numeroAvisPub',
        component: VisualiserAvisDePubComponent,
        data: { breadcrumb: 'breadcrumb.visualiser' }
      },
      {
        path: 'creerAvisPub',
        component: StepperComponent,
        data: { breadcrumb: 'breadcrumb.creerPub' }
      },
      {
        path: 'editerAvisPub/:numeroAvisPub',
        component: StepperComponent,
        data: { breadcrumb: 'breadcrumb.creerPub' }
      },
      {
        path: '',
        component: HomeAvisDePubComponent,
        data: { breadcrumb: null },
        pathMatch: 'prefix'
      },
	  {
		path :'ImportAvis',
		component: ImportComponent
	  }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AvisDePubRoutingModule {
}
